import { ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableLazyLoadEvent } from 'primeng/table';
import { NXDataSourcePrime } from '../../dataSource/NXDataSourcePrime';
import { LoadingService } from '../../shared/services/loading.service';
import { RolesService } from '../../shared/services/roles/roles.service';
import { TenantsService } from '../../shared/services/tenants/tenants.service';
import { EditDialogService } from '../editDialog/editDialogService';
import { MobileDeviceDataSource } from './mobileDeviceDataSource';

@Component({
  selector: 'app-mobile-device-list',
  templateUrl: './mobile-device-list.component.html',
  styleUrls: ['./mobile-device-list.component.scss']
})
export class MobileDeviceListComponent implements OnDestroy {

  dialogRef: DynamicDialogRef | undefined;

  public sortProperty: string;
  public defaultSortProperty: string = 'id';
  public sortDirection: string;
  public defaultSortDirection: string = 'asc';
  public pageNumber = 0;
  public pageSize = 15;
  public sortModel: any;
  public sortOptions = [
    { label: 'Keine Sortierung', fieldName: 'id', direction: "asc"},
    { label: 'Zuletzt gesehen aufsteigend', fieldName: 'lastSeenDateTime', direction: "asc"},
    { label: 'Zuletzt gesehen absteigend', fieldName: 'lastSeenDateTime', direction: "desc" },
    { label: 'Erstellt aufsteigend', fieldName: 'createdDateTime', direction: "asc"},
    { label: 'Erstellt absteigend', fieldName: 'createdDateTime', direction: "desc" }
  ];

  public dataSource: MobileDeviceDataSource;
  public loading = false;
  public appVersion: string;

  constructor(
    private router: Router,
    private apollo: Apollo,
    public tenantService:TenantsService,
    public rolesService: RolesService,
    private cdRef: ChangeDetectorRef,
    public dialogService: EditDialogService,
    public loadingService: LoadingService,
    @Inject('env') private environment : any

  ) {
  }

  ngOnInit(): void {
    this.dataSource = new MobileDeviceDataSource(this.apollo, this.environment);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.dataSource.loadTenants({
      pageNumber: 0,
      pageSize: 15,
      sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
      appVersion: this.appVersion
    });
  }

  refetchTenants(force = false): void {
    this.dataSource.refetchQuery({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
      appVersion: this.appVersion
    }, force);
  }

  ngOnDestroy(): void {
    this.dataSource.disconnect();
  }

  loadData(event: TableLazyLoadEvent) {
    this.loading = true;

    // sorting
    if (event?.sortField !== undefined && typeof event?.sortField == 'string') {
      this.sortProperty = event.sortField;
    }
    if (event?.sortOrder !== undefined) {
      this.sortDirection = NXDataSourcePrime.translateSortOrderToSortDirection(event.sortOrder);
    }

    //filtering
    this.appVersion = event.globalFilter as string;

    // pagination
    this.pageNumber = event?.first !== undefined ? event.first / event.rows : 0;
    this.pageSize = event?.rows !== undefined ? event.rows : 15;

    this.refetchTenants();
  }

  sort(event: any) {
    if(event?.value?.direction && event?.value?.fieldName){
      this.sortProperty = event.value.fieldName;
      this.sortDirection = event.value.direction;
    } else {
      this.sortProperty = this.defaultSortProperty;
      this.sortDirection = this.defaultSortDirection;
    }
    this.cdRef.detectChanges();
  }

  translateSortDirectionToSortOrder(sortDirection: string): number {
    return NXDataSourcePrime.translateSortDirectionToSortOrder(sortDirection);
  }

  calculateSeverity(updateState: string): string {
   // NO_UPDATE, SHOULD_UPDATE, MUST_UPDATE
   switch (updateState) {
      case 'NO_UPDATE':
        return 'success';
      case 'SHOULD_UPDATE':
        return 'warning';
      case 'MUST_UPDATE':
        return 'danger';
      default:
        return 'success';
    }
  }

  updateLabel(updateState: string): string {
    // NO_UPDATE, SHOULD_UPDATE, MUST_UPDATE
    switch (updateState) {
      case 'NO_UPDATE':
        return 'ok';
      case 'SHOULD_UPDATE':
        return 'empfohlen';
      case 'MUST_UPDATE':
        return 'erforderlich';
      default:
        return 'ok';
    }
  }

}
